import { GET_CP_QP_NAMES } from './../../../shared/constants/data-capture-api-constant';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ApiService } from './../../../core/services/api.service';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { AuthService } from '../../../core/services/auth.service';
import { Dropdown } from 'src/app/shared/models/dropdown.model';

@Injectable({
  providedIn: 'root',
})
export class DataCaptureService {
  public tabs: Dropdown[];
  public updateHeaders = new BehaviorSubject(null);
  public updateAllTabsVisited = new BehaviorSubject([]);
  public resetTabVisited = new Subject();
  public isFormWithError = new Subject<boolean>();
  userRole: any;
  isReadOnlyMode = false;
  cpqpNames: any;

  constructor(
    private apiService: ApiService,
    private router: Router,
    private authService: AuthService
  ) {
    if (this.router.url.indexOf('view-manage-workflows') > -1) {
      this.isReadOnlyMode = true;
    } else {
      this.isReadOnlyMode = false;
    }
  }

  public getConsumerRoleType() {
    this.userRole = this.authService.getUserRoles();
    if (this.router.url.indexOf('view-manage-workflows') > -1) {
      return true;
    }
  }

  // public uploadFile(file, workflowID, yearCode, tabCode): Observable<any> {
  //   return this.apiService.postData(
  //     `dataCapture/upload/${workflowID}/${yearCode}/${tabCode}`,
  //     file
  //   );
  // }

  public uploadExcelFile(file, workflowID, yearCode, tabCode): Observable<any> {
    return this.apiService.postData(
      `dataCapture/uploadExcel/${workflowID}/${yearCode}/${tabCode}`,
      file
    );
  }

  public downloadExcelFile(workflowID, yearCode, tabCode): Observable<any> {
    return this.apiService.postData(
      `dataCapture/downloadExcel/${workflowID}/${yearCode}/${tabCode}`,
      {}
    );
  }

  public getCPQPNames(workflowID): Observable<any> {
    if (
      sessionStorage.getItem(`${GET_CP_QP_NAMES}/${workflowID}`) &&
      sessionStorage.getItem(`${GET_CP_QP_NAMES}/${workflowID}`) !==
        'undefined' &&
      sessionStorage.getItem(`${GET_CP_QP_NAMES}/${workflowID}`) !== 'null'
    ) {
      return new Observable((observer) => {
        observer.next(
          JSON.parse(sessionStorage.getItem(`${GET_CP_QP_NAMES}/${workflowID}`))
        );
        observer.complete();
      });
    }
    return this.apiService.fetchData(`${GET_CP_QP_NAMES}/${workflowID}`);
  }

  public setCPQPNames(cpqpNames, workflowID): void {
    sessionStorage.setItem(
      `${GET_CP_QP_NAMES}/${workflowID}`,
      JSON.stringify(cpqpNames)
    );
    this.cpqpNames = cpqpNames;
    setTimeout(() => {
      sessionStorage.setItem(`${GET_CP_QP_NAMES}/${workflowID}`, null);
    }, 3000);
  }
}
